import { UserRole } from '@/utils/interfaces/common/UserRole.enum';
import { createContext, Dispatch, SetStateAction } from 'react';

export interface IBackButtonConfig {
  show?: boolean;
  url?: string;
  disabled?: boolean;
  popConfirm?: boolean;
  title?: string;
}

type ICommonContentContext = {
  userProfile: UserRole | undefined;
  setUserProfile: (value: UserRole) => void;
  showMenu: boolean | undefined;
  setShowMenu: (value: boolean) => void;
  navbarWithMenu: boolean | undefined;
  setNavbarWithMenu: (value: boolean) => void;
  disableElement: boolean;
  setDisableElement: (value: boolean) => void;
  recordMachinesAndImplements: boolean;
  setRecordMachinesAndImplements: (value: boolean) => void;
  modalErrors: (errors: string[]) => void;
  tenantId: string | null;
  setTenantId: (value: string | null) => void;
  backButtonConfig: IBackButtonConfig;
  setBackButtonConfig: (value: IBackButtonConfig) => void;
  farmId: number | null;
  setFarmId: Dispatch<SetStateAction<number | null>>;
};

export const CommonContentContext = createContext<ICommonContentContext>({
  userProfile: 0,
  setUserProfile: () => {
    console.warn('setUserProfile is called');
  },
  showMenu: true,
  setShowMenu: () => {
    console.warn('setShowMenu is called');
  },
  navbarWithMenu: false,
  setNavbarWithMenu: () => {
    console.warn('setNavbarWithMenu is called');
  },
  disableElement: false,
  setDisableElement: () => {
    console.warn('setDisableElement is called');
  },
  recordMachinesAndImplements: false,
  setRecordMachinesAndImplements: () => {
    console.warn('setRecordMachinesAndImplements is called');
  },
  modalErrors: () => {
    console.warn('modalErrors is called');
  },
  tenantId: null,
  setTenantId: () => {
    console.warn('setTenantId is called');
  },
  backButtonConfig: { show: false },
  setBackButtonConfig: () => {
    console.warn('setBackButtonConfig is called');
  },
  farmId: null,
  setFarmId: () => {
    console.warn('setFarmId is called');
  },
});
